// extracted by mini-css-extract-plugin
module.exports = {"text":"text--cMYPj","editable":"editable--G9CeU"};